/**
 * Async actions for Settings Gmail section (keeps component CRAP low).
 */

import type { UserSettingsPublic } from '../../services/clients/types';
import { providerOAuthClient } from '../../services/clients';

export async function startGmailOAuthFlow(opts: {
  setBusy: (busy: boolean) => void;
  setError: (message: string | null) => void;
}): Promise<void> {
  opts.setBusy(true);
  opts.setError(null);
  try {
    const envelope = await providerOAuthClient.start('gmail');
    window.location.assign(envelope.data.authorizeUrl);
  } catch (err) {
    opts.setError(
      err instanceof Error
        ? err.message
        : 'OAuth de Gmail no está disponible. Configura GMAIL_OAUTH_* en el servidor.',
    );
    opts.setBusy(false);
  }
}

export async function disconnectGmailOAuthFlow(opts: {
  setBusy: (busy: boolean) => void;
  setError: (message: string | null) => void;
  onSettingsRefresh?: (data: UserSettingsPublic) => void;
}): Promise<void> {
  opts.setBusy(true);
  opts.setError(null);
  try {
    const envelope = await providerOAuthClient.disconnect('gmail');
    opts.onSettingsRefresh?.(envelope.data);
  } catch (err) {
    opts.setError(err instanceof Error ? err.message : 'No se pudo desconectar Gmail');
  } finally {
    opts.setBusy(false);
  }
}
